import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { zIndex, typography, getResetByTag, utilityStyles, rem } from './../../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("font-size:", rem(12), ";font-weight:", typography.typographyFontWeightBold, ";line-height:", typography.typographyLineHeightXs, ";position:relative;text-align:center;width:100%;z-index:", zIndex.zIndex_1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('span');
var StyledButtonGroupItemText = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "et5m6mj0"
} : {
  target: "et5m6mj0",
  label: "StyledButtonGroupItemText"
})(resetStyles, defaultStyles, utilityStyles);
export default StyledButtonGroupItemText;